<ol class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs">
    <span>
      {{ breadcrumb.label }}
    </span>
  </li>
</ol>
